module.exports = __webpack_public_path__ + "routes/services/waiting-wheel-300x300.gif?04fcf026";


//////////////////
// WEBPACK FOOTER
// ./routes/services/waiting-wheel-300x300.gif
// module id = 1481
// module chunks = 0